import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment } from "@mui/material";
import { useState } from "react";
import InputField, { InputFieldProps } from "./InputField";

export type PasswordFieldProps = Omit<InputFieldProps, "type" | "endAdornment">;

/** Common password input with a show/hide toggle. Works as an antd `Form.Item` child. */
const PasswordField = (props: PasswordFieldProps) => {
  const [visible, setVisible] = useState(false);
  return (
    <InputField
      {...props}
      type={visible ? "text" : "password"}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            size="small"
            edge="end"
            tabIndex={-1}
            aria-label={visible ? "Hide password" : "Show password"}
            onClick={() => setVisible((prev) => !prev)}
            onMouseDown={(e) => e.preventDefault()}
          >
            {visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
          </IconButton>
        </InputAdornment>
      }
    />
  );
};

export default PasswordField;
